<script>
  export let currentURL;
  export let showMenu;

  import ContextMenuItem from "./ContextMenuItem.svelte";

  import {
    addDomainNoNavMenu,
    removeDomainNoNavMenu,
    showDomainNavMenu,
  } from "../js/localInfo";

  import { onMount } from "svelte";

  $: if (currentURL) {
    currentURL =
      currentURL.startsWith("/") || currentURL.startsWith("http")
        ? currentURL
        : "https://" + currentURL;
  }

  onMount(() => {
    shortcut.remove("Shift+4");
    shortcut.remove("F4");

    shortcut.add("Shift+4", function () {
      toggleMenu();
    });

    shortcut.add("F4", function () {
      toggleMenu();
    });

    let div = document.getElementsByTagName("body");
    //console.log(div);

    div[0].addEventListener(
      "contextmenu",
      function (e) {
        if (currentURL !== "") {
          let divCM = window.$("#contextMenu");
          divCM.addClass("contextMenuShow");

          document.getElementById("contextMenu").style.top = mouseY(e) + "px";
          document.getElementById("contextMenu").style.left = mouseX(e) + "px";

          div[0].addEventListener("click", onClickOutside);

          e.preventDefault();
        }
      },
      false
    );

    window.addEventListener("storage", function (e) {
      showMenu = showDomainNavMenu(currentURL);
    });
  });

  let mouseX = (evt) => {
    if (evt.pageX) {
      return evt.pageX;
    } else if (evt.clientX) {
      return (
        evt.clientX +
        (document.documentElement.scrollLeft
          ? document.documentElement.scrollLeft
          : document.body.scrollLeft)
      );
    } else {
      return null;
    }
  };

  let mouseY = (evt) => {
    if (evt.pageY) {
      return evt.pageY;
    } else if (evt.clientY) {
      return (
        evt.clientY +
        (document.documentElement.scrollTop
          ? document.documentElement.scrollTop
          : document.body.scrollTop)
      );
    } else {
      return null;
    }
  };

  let onClickOutside = (event) => {
    let divCM = window.$("#contextMenu");
    divCM.removeClass("contextMenuShow");
    document.removeEventListener("click", onClickOutside);
  };

  let toggleMenu = () => {
    showMenu = !showMenu;
  };

  let openURL = () => {
    window.open("/openexternal/#/" + currentURL);
  };

  $: if (currentURL) {
    showMenu = showDomainNavMenu(currentURL);
  }

  $: if (showMenu !== null) {
    if (showMenu === true) {
      removeDomainNoNavMenu(currentURL);
    }
    if (showMenu === false) {
      addDomainNoNavMenu(currentURL);
    }
  }
</script>

{#if currentURL}
  <div id="contextMenu" class="contextMenu">
    <ContextMenuItem
      img={showMenu
        ? "/images/navigation/expand.svg"
        : "/images/navigation/shrink.svg"}
      imgHover={showMenu
        ? "/images/navigation/expand-white.svg"
        : "/images/navigation/shrink-white.svg"}
      text={showMenu ? "Hide navigation bar" : "Show navigation bar"}
      onClick={() => toggleMenu()}
    />
    <ContextMenuItem
      img="/images/navigation/out.svg"
      imgHover="/images/navigation/out-white.svg"
      text="Open in default browser"
      onClick={() => openURL()}
    />
  </div>
{/if}

<style>
  div#contextMenu {
    background-color: var(--labit-dialog-background);
    border: 1px solid var(--labit-card-gray);
    border-radius: 5px;
  }
</style>
